import * as React from "react";
import { Tag } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

interface PreliminaryAnswersColumnProps {
  count: number;
  hasRejected: boolean;
}

export const PreliminaryAnswersColumn: React.FunctionComponent<PreliminaryAnswersColumnProps> = ({
  count,
  hasRejected,
}) => {
  return (
    <>
      {count ? <Tag>{count}</Tag> : "-"}
      {hasRejected && <FontAwesomeIcon icon="exclamation" fixedWidth={true} />}
    </>
  );
};
